<section class="section-lg trustedby">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <h3>全球领军企业的信赖之选</h3>
            </div>
            <div class="col-12">
                <div id="client-logos_white" class="owl-carousel">
                    <div *ngFor="let logo of clientLogos" class="item">
                        <div class="clientLogo">
                          <img [src]="logo.src" [width]="logo.width" [height]="logo.height" loading="lazy" [class]="logo.class" [alt]="logo.alt" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>